export const INLINE_SECTION_WORD_LIMIT = 500;

export const INLINE_SECTION_WORD_MESSAGE =
  'Longer text needs its own page. Inline sections are limited to 500 words.';

/** Words in section HTML, after tags are removed. */
export function countSectionWords(html: string): number {
  const text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&#?\w+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!text) return 0;
  return text.split(' ').length;
}
